module.exports = __webpack_public_path__ + "img/logo.ea66e1ce.png";